/* mtx-variant-fix:v4 */
import { d as disableTabulationOnNotActiveSlidesWithModel } from "./disableTabulationOnNotActiveSlidesWithModel-38e80234.js";
const selectors$2 = {
  container: "[data-js-product-container]",
  form: "[data-js-product-form]",
  product: "[data-js-product-json]",
  sku: ".js-product-sku",
  price: ".js-price",
  productPrice: "[data-product-price]",
  productPriceOld: "[data-price-old]",
  priceUnit: "[data-js-unit-price]",
  productPriceDiscount: "[data-product-price-discount]",
  variantId: '[name="id"]',
  submit: '[type="submit"]',
  quantityError: ".js-product-quantity-error",
  variants: "[data-js-product-variant]",
  variantElemJSON: "[data-selected-variant]",
  isPreset: "[data-is-preset]",
  productInventoryWrapper: ".js-product-inventory-wrapper",
  lowStockText: ".js-product-low-stock-msg",
  highStockText: ".js-product-high-stock-msg",
  stickyBar: ".js-sticky-add-to-cart",
  stickyBarButton: ".js-sticky-add-to-cart-button",
  recipientCheckbox: ".js-recipient-form-checkbox",
  recipientFieldsContainer: ".js-recipient-form-fields",
  recipientField: ".js-recipient-form-field",
  recipientTimeZoneOffset: ".js-recipient-form-timezone-offset",
  recipientNoJsControl: ".js-recipient-form-no-js-control",
  customFieldGroup: ".js-custom-field-block",
  customFieldInput: ".js-custom-field-input",
  customFieldCheckbox: ".js-custom-field-checkbox",
  animate: ".js-animate",
  breaksVal: ".js-price-breaks-val",
  volumePricing: ".js-product-volume-pricing",
  quantityRuleMin: ".js-product-quantity-rule-min",
  quantityRuleMax: ".js-product-quantity-rule-max",
  quantityRuleIncrement: ".js-product-quantity-rule-increment",
  quantityRuleMinVal: ".js-product-quantity-rule-min-val",
  quantityRuleMaxVal: ".js-product-quantity-rule-max-val",
  quantityRuleIncrementVal: ".js-product-quantity-rule-increment-val",
  volumePricingList: ".js-product-volume-pricing-list",
  volumePricingJSON: "[data-product-qty-breaks-json]",
  volumePricingShowMore: ".js-product-volume-pricing-show-more",
  priceVolume: ".js-price-volume",
  formError: ".js-form-error",
  swatchLabelName: ".js-swatch-label-name",
  quantityRules: ".js-product-quantity-rules",
  productAddToCartText: ".js-product-add-to-cart-button-text",
  inventoryStatusQuantity: ".js-product-inventory-status-quantity"
};
let classes = {};
const attributes = {
  id: "id",
  isCurrencyEnabled: "data-currency-code-enabled"
};
const cachedOptions = /* @__PURE__ */ new Map();
let fetchController = new AbortController();
let prefetchController = new AbortController();
let isUpdatingVariant = false;
const ProductForm = () => {
  let convertFormData;
  let QuantityWidget;
  let cssClasses2;
  let formatMoney;
  let getUrlWithVariant;
  let containers = [];
  let forms = [];
  function init2() {
    window.themeCore.utils.arrayIncludes;
    convertFormData = window.themeCore.utils.convertFormData;
    QuantityWidget = window.themeCore.utils.QuantityWidget;
    cssClasses2 = window.themeCore.utils.cssClasses;
    formatMoney = window.themeCore.utils.formatMoney;
    getUrlWithVariant = window.themeCore.utils.getUrlWithVariant;
    classes = {
      ...cssClasses2,
      onSale: "price--on-sale",
      hidePrice: "price--hide",
      animate: "js-animate",
      animated: "animated"
    };
    containers = findContainers();
    forms = setForms();
    setEventListeners();
    setEventBusListeners2();
    initFirstState();
    showOptions();
    initStickyBar();
    initRecipientForm();
  }
  function setEventListeners() {
    forms.forEach(({ container, form }) => {
      container.addEventListener("change", onChangeForm);
      form.addEventListener("submit", onFormSubmit);
    });
    window.themeCore.EventBus.listen("cart:updated", function(cartData) {
      if (!cartData) {
        return;
      }
      if (!cartData.items) {
        return;
      }
      containers.forEach(function(container) {
        const currentVariant = findCurrentVariant(container);
        const quantityVariantInCart = getVariantCountInCart(currentVariant);
        updateVolumePricing(container, currentVariant, quantityVariantInCart, false);
        updateQuantityRules(container, currentVariant);
        updateQuantityLabelCartCount(container, quantityVariantInCart);
      });
    });
  }
  function setEventBusListeners2() {
    if (forms.length) {
      forms.forEach(({ form }) => {
        const formId = form.getAttribute("id");
        window.themeCore.EventBus.listen(`form:${formId}:change-variant`, updateForm);
      });
    }
  }
  function updateForm({ currentVariant, elements, container, isTrusted, product }) {
    const quantityVariantInCart = getVariantCountInCart(currentVariant);
    if (isTrusted) {
      updateSwatchLabelName(currentVariant, container);
      updateSku(elements, currentVariant);
      updateSku({ skuContainer: elements.mobileSkuContainer }, currentVariant);
      // Only for subscription-required products: keep selling_plan valid for seat tier
      syncSellingPlanForVariant(currentVariant, container, product);
      updatePrice(elements, currentVariant, container, product);
      updateVariantId(elements, currentVariant);
      updateErrorMessages(elements);
      updateAddToCart(elements, currentVariant);
      updatePickupAvailability(currentVariant, container);
    }
    updateVolumePricing(container, currentVariant, quantityVariantInCart, isTrusted);
    updateQuantityRules(container, currentVariant);
    updateQuantityLabelCartCount(container, quantityVariantInCart);
  }
  /** True only when purchase must include a selling plan (subscription-only PDPs). */
  function productRequiresSellingPlan(product, variant) {
    if (variant && variant.requires_selling_plan) {
      return true;
    }
    if (product && product.requires_selling_plan) {
      return true;
    }
    return false;
  }
  /**
   * Subscription-only products often use $0 variant prices; the charge lives on
   * selling_plan_allocations. Regular products (and OTP on mixed products) use
   * variant.price — never override them with a subscription allocation.
   */
  function getSelectedSellingPlanId(container) {
    if (!container) {
      return null;
    }
    const checked = container.querySelector('input[type="radio"][name="selling_plan"]:checked');
    if (checked && checked.value) {
      return String(checked.value);
    }
    const form = container.querySelector(selectors$2.form) || container;
    const formId = form && form.getAttribute && form.getAttribute("id");
    if (formId) {
      const associated = document.querySelector(
        `input[type="radio"][name="selling_plan"][form="${formId}"]:checked`
      );
      if (associated && associated.value) {
        return String(associated.value);
      }
    }
    // OTP tabs from Shopify Subscriptions use empty value — treat as no plan
    const otp = container.querySelector('[id^="tab_otp_"]:checked, input[id^="tab_otp_"]:checked');
    if (otp) {
      return null;
    }
    const hidden = form && form.querySelector && form.querySelector(
      'input[name="selling_plan"]:not([type="radio"]):not([type="checkbox"])'
    );
    if (hidden && hidden.value && !hidden.disabled) {
      return String(hidden.value);
    }
    return null;
  }
  function getVariantDisplayPricing(variant, container, product) {
    if (!variant) {
      return { price: 0, compare_at_price: null };
    }
    const price = variant.price;
    const compare_at_price = variant.compare_at_price;
    const allocations = variant.selling_plan_allocations || [];
    if (!allocations.length) {
      return { price, compare_at_price };
    }
    const planId = getSelectedSellingPlanId(container);
    const requiresPlan = productRequiresSellingPlan(product, variant);
    // Mixed subscribe+OTP products: only use allocation when a plan is selected
    if (planId) {
      const allocation = allocations.find((a) => String(a.selling_plan_id) === planId);
      if (allocation) {
        return {
          price: allocation.price,
          compare_at_price: allocation.compare_at_price != null ? allocation.compare_at_price : compare_at_price
        };
      }
    }
    // Subscription-only: show a plan price (prefer non-zero) so $0 base variants still display
    if (requiresPlan) {
      const allocation = allocations.find((a) => Number(a.price) > 0) || allocations[0];
      if (allocation) {
        return {
          price: allocation.price,
          compare_at_price: allocation.compare_at_price != null ? allocation.compare_at_price : compare_at_price
        };
      }
    }
    // Default: one-time / normal product price
    return { price, compare_at_price };
  }
  function syncSellingPlanForVariant(variant, container, product) {
    if (!variant || !container) {
      return;
    }
    const allocations = variant.selling_plan_allocations || [];
    const form = container.querySelector(selectors$2.form);
    if (!form) {
      return;
    }
    let hidden = form.querySelector(
      'input[name="selling_plan"]:not([type="radio"]):not([type="checkbox"])'
    );
    if (!allocations.length) {
      // Non-subscription product: leave form alone (do not inject selling_plan)
      if (hidden && !productRequiresSellingPlan(product, variant)) {
        hidden.value = "";
        hidden.disabled = true;
      }
      return;
    }
    if (!hidden) {
      // Only create the field when this product actually needs selling plans
      if (!productRequiresSellingPlan(product, variant)) {
        return;
      }
      hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = "selling_plan";
      form.appendChild(hidden);
    }
    const currentId = hidden.value ? String(hidden.value) : "";
    const stillValid = currentId && allocations.some((a) => String(a.selling_plan_id) === currentId);
    const requiresPlan = productRequiresSellingPlan(product, variant);
    if (requiresPlan) {
      // Must always have a plan for this variant's group
      if (!stillValid) {
        const next = allocations.find((a) => Number(a.price) > 0) || allocations[0];
        if (next && next.selling_plan_id != null) {
          hidden.value = String(next.selling_plan_id);
          hidden.disabled = false;
          hidden.removeAttribute("disabled");
        }
      } else {
        hidden.disabled = false;
        hidden.removeAttribute("disabled");
      }
      return;
    }
    // Optional subscriptions: clear invalid plan ids; never auto-select a plan
    if (currentId && !stillValid) {
      hidden.value = "";
      hidden.disabled = true;
    }
  }
  function updatePickupAvailability(variant, container) {
    const pickUpAvailability = container.querySelector("pickup-availability");
    if (!pickUpAvailability) {
      return;
    }
    if (variant && variant.available) {
      pickUpAvailability.fetchAvailability(variant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }
  function updateSwatchLabelName(variant, container) {
    const swatchNameEl = container.querySelector(selectors$2.swatchLabelName);
    if (!swatchNameEl) {
      return;
    }
    if (!variant) {
      const swatchName = swatchNameEl.getAttribute("data-swatch-name");
      const swatchOptionSelected = container.querySelector(`[data-option='${swatchName}']:checked`);
      if (swatchOptionSelected) {
        swatchNameEl.textContent = swatchOptionSelected.value;
      }
      return;
    }
    const optionPosition = swatchNameEl.getAttribute("data-swatch-position");
    const optionLabel = "option" + optionPosition;
    const optionName = variant[optionLabel];
    if (!optionName) {
      return;
    }
    swatchNameEl.textContent = optionName;
  }
  function updatePrice({ priceContainers }, variant, container, product) {
    if (!variant) {
      priceContainers.forEach((priceContainer) => priceContainer.classList.add(classes.hidePrice));
      updateUnitPrice(priceContainers, {});
      return;
    } else if (!priceContainers.length) {
      return;
    }
    const { price, compare_at_price } = getVariantDisplayPricing(variant, container, product);
    priceContainers.forEach((priceContainer) => {
      const isCurrencyEnabled = priceContainer.hasAttribute(attributes.isCurrencyEnabled);
      const format = isCurrencyEnabled ? window.themeCore.objects.shop.money_with_currency_format : window.themeCore.objects.shop.money_format;
      const onSale = compare_at_price != null && compare_at_price > price;
      const moneyPrice = formatMoney(price, format);
      const moneyPriceOld = compare_at_price != null ? formatMoney(compare_at_price, format) : "";
      priceContainer.classList.remove(classes.hidePrice);
      if (onSale) {
        priceContainer.classList.add(classes.onSale);
        const productPriceDiscount = priceContainer.querySelector(selectors$2.productPriceDiscount);
        const discountPercentage = (compare_at_price - price) / compare_at_price * 100;
        if (productPriceDiscount)
          productPriceDiscount.innerHTML = `-${Math.ceil(discountPercentage)}%`;
      } else {
        priceContainer.classList.remove(classes.onSale);
      }
      const productPrice = priceContainer.querySelectorAll(selectors$2.productPrice);
      const productPriceOld = priceContainer.querySelectorAll(selectors$2.productPriceOld);
      productPrice.forEach((element) => {
        element.innerHTML = moneyPrice;
        element.setAttribute("data-amount", String(price));
      });
      productPriceOld.forEach((element) => {
        element.innerHTML = moneyPriceOld;
        if (compare_at_price != null) {
          element.setAttribute("data-amount", String(compare_at_price));
        }
      });
    });
    updateUnitPrice(priceContainers, variant);
  }
  function updateUnitPrice(priceContainers, variant) {
    priceContainers.forEach((priceContainer) => {
      const unitPrice = [...priceContainer.querySelectorAll(selectors$2.priceUnit)];
      if (!unitPrice.length) {
        return;
      }
      const unitPriceContainerEl = unitPrice.find((element) => element.dataset.jsUnitPrice === "container");
      const unitPriceMoneyEl = unitPrice.find((element) => element.dataset.jsUnitPrice === "money");
      const unitPriceReferenceEl = unitPrice.find((element) => element.dataset.jsUnitPrice === "reference");
      const variantUnitPrice = variant.unit_price;
      const variantUnitPriceMeasurement = variant.unit_price_measurement;
      if (unitPriceMoneyEl) {
        if (variantUnitPrice) {
          const format = window.themeCore.objects.shop.money_format;
          unitPriceMoneyEl.innerHTML = formatMoney(variantUnitPrice, format);
        } else {
          unitPriceMoneyEl.innerHTML = "";
        }
      }
      if (unitPriceReferenceEl) {
        if (variantUnitPriceMeasurement) {
          const referenceValue = variantUnitPriceMeasurement.reference_value;
          const referenceUnit = variantUnitPriceMeasurement.reference_unit;
          unitPriceReferenceEl.innerHTML = referenceValue !== 1 ? referenceValue + referenceUnit : referenceUnit;
        } else {
          unitPriceReferenceEl.innerHTML = "";
        }
      }
      if (unitPriceContainerEl && (variantUnitPrice || variantUnitPriceMeasurement)) {
        unitPriceContainerEl.classList.remove(window.themeCore.utils.cssClasses.hidden);
      } else {
        unitPriceContainerEl.classList.add(window.themeCore.utils.cssClasses.hidden);
      }
    });
  }
  function updateSku({ skuContainer }, variant) {
    if (!skuContainer) {
      return;
    }
    let sku = null;
    if (variant) {
      sku = variant.sku;
    }
    if (!sku) {
      const isPreset = skuContainer.closest(selectors$2.isPreset);
      if (isPreset && isPreset.dataset.isPreset === "true") {
        return;
      }
      skuContainer.innerHTML = "";
      return;
    }
    const skuText = skuContainer.dataset.skuText;
    skuContainer.innerHTML = skuText ? skuText.replaceAll("{SKU}", sku).replaceAll("{sku}", sku) : sku;
  }
  function updateVariantId({ variantIdContainers }, variant) {
    if (!variant) {
      return;
    }
    const { id } = variant;
    const changedInputs = [];
    if (variantIdContainers && variantIdContainers.length) {
      variantIdContainers.forEach((variantIdContainer) => {
        const previous = variantIdContainer.value;
        variantIdContainer.value = id;
        if (String(previous) !== String(id)) {
          changedInputs.push(variantIdContainer);
        }
      });
    }
    // Notify listeners after theme update finishes. Bubbling change on name="id"
    // is ignored by onChangeForm (no data-option) but Subscriptions app needs it.
    queueMicrotask(() => {
      changedInputs.forEach((variantIdContainer) => {
        variantIdContainer.dispatchEvent(new Event("input", { bubbles: true }));
        variantIdContainer.dispatchEvent(new Event("change", { bubbles: true }));
      });
      document.dispatchEvent(
        new CustomEvent("variant:change", {
          bubbles: true,
          detail: { variant, variantId: id }
        })
      );
    });
  }
  function getSelectedOptionValueIds(optionsContainer) {
    if (!optionsContainer) {
      return [];
    }
    return Array.from(
      optionsContainer.querySelectorAll("select[data-option] option[selected], input[data-option]:checked")
    ).map((el) => el.dataset.optionValueId).filter((id) => id != null && String(id).length > 0);
  }
  function findVariantBySelectedOptions(product, optionsContainer) {
    if (!product || !product.variants || !optionsContainer) {
      return null;
    }
    const optionNames = product.options || [];
    const selectedValues = [];
    for (let i = 0; i < optionNames.length; i++) {
      const name = optionNames[i];
      let input = null;
      try {
        input = optionsContainer.querySelector(
          `input[data-option="${CSS.escape(name)}"]:checked, select[data-option="${CSS.escape(name)}"]`
        );
      } catch (e) {
        input = optionsContainer.querySelector(
          `input[data-option="${name}"]:checked, select[data-option="${name}"]`
        );
      }
      if (!input) {
        return null;
      }
      selectedValues.push(input.value);
    }
    return product.variants.find((variant) => {
      return selectedValues.every((value, index) => String(variant[`option${index + 1}`]) === String(value));
    }) || null;
  }
  function updateErrorMessages({ quantityError }) {
    if (!quantityError) {
      return;
    }
    quantityError.innerHTML = "";
  }
  function updateAddToCart({ submit }, currentVariant) {
    const removeDisabled = () => submit.forEach((button) => button.removeAttribute("disabled"));
    const setDisabled = () => submit.forEach((button) => button.setAttribute("disabled", "disabled"));
    const setSubmitText = (text) => submit.forEach((button) => {
      const buttonText = button.querySelector(selectors$2.productAddToCartText);
      buttonText.innerText = text;
    });
    const isPreorderTemplate = submit.some((button) => button.hasAttribute("data-preorder"));
    const soldOut = window.themeCore.translations.get("products.product.sold_out");
    const unavailable = window.themeCore.translations.get("products.product.unavailable");
    const preOrder = window.themeCore.translations.get("products.product.pre_order");
    const addToCart = isPreorderTemplate ? preOrder : window.themeCore.translations.get("products.product.add_to_cart");
    if (currentVariant && currentVariant.available) {
      removeDisabled();
      setSubmitText(addToCart);
    } else if (currentVariant && !currentVariant.available) {
      setDisabled();
      setSubmitText(soldOut);
    } else {
      setDisabled();
      setSubmitText(unavailable);
    }
  }
  function updateQuantityRules(container, variant) {
    const currentContainerData = forms.find((form) => form.container.getAttribute("data-section-id") === container.getAttribute("data-section-id"));
    const quantityWidgetEl = currentContainerData.elements.quantityWidgetEl;
    const quantityRules = container.querySelector(selectors$2.quantityRules);
    if (!quantityRules) {
      return;
    }
    if (!variant || variant && !variant.quantity_rule) {
      quantityRules.classList.add(cssClasses2.hidden);
      return;
    } else {
      quantityRules.classList.remove(cssClasses2.hidden);
    }
    const variantQuantityRules = variant.quantity_rule;
    const quantityRuleIncrement = quantityRules.querySelector(selectors$2.quantityRuleIncrement);
    const quantityRuleMin = quantityRules.querySelector(selectors$2.quantityRuleMin);
    const quantityRuleMax = quantityRules.querySelector(selectors$2.quantityRuleMax);
    const quantityRuleIncrementVal = quantityRules.querySelector(selectors$2.quantityRuleIncrementVal);
    const quantityRuleMinVal = quantityRules.querySelector(selectors$2.quantityRuleMinVal);
    const quantityRuleMaxVal = quantityRules.querySelector(selectors$2.quantityRuleMaxVal);
    if (quantityRuleIncrementVal) {
      quantityRuleIncrementVal.textContent = window.themeCore.translations.get("products.product.increments_of", { number: variantQuantityRules.increment });
      quantityWidgetEl.setIncrement(variantQuantityRules.increment);
      variantQuantityRules.increment > 1 ? quantityRuleIncrement.classList.remove(cssClasses2.hidden) : quantityRuleIncrement.classList.add(cssClasses2.hidden);
    }
    if (quantityRuleMinVal) {
      quantityRuleMinVal.textContent = window.themeCore.translations.get("products.product.minimum_of", { number: variantQuantityRules.min });
      quantityWidgetEl.setMin(variantQuantityRules.min);
      quantityWidgetEl.toggleDecrease();
      quantityWidgetEl.toggleIncrease();
      variantQuantityRules.min > 1 ? quantityRuleMin.classList.remove(cssClasses2.hidden) : quantityRuleMin.classList.add(cssClasses2.hidden);
    }
    if (quantityRuleMaxVal) {
      if (variantQuantityRules.max !== null) {
        quantityRuleMaxVal.textContent = window.themeCore.translations.get("products.product.maximum_of", { number: variantQuantityRules.max });
        quantityRuleMax.classList.remove(cssClasses2.hidden);
        quantityWidgetEl.setMax(variantQuantityRules.max);
      } else {
        quantityRuleMaxVal.textContent = "";
        quantityRuleMax.classList.add(cssClasses2.hidden);
        quantityWidgetEl.setMax("");
      }
      quantityWidgetEl.toggleDecrease();
      quantityWidgetEl.toggleIncrease();
    }
    if (variantQuantityRules.increment < 2 && variantQuantityRules.min < 2 && variantQuantityRules.max === null) {
      quantityRules.classList.add(cssClasses2.hidden);
    } else {
      quantityRules.classList.remove(cssClasses2.hidden);
    }
  }
  function updateVolumePricing(container, variant, quantity, isTrusted) {
    const currentContainerData = forms.find((form) => form.container.getAttribute("data-section-id") === container.getAttribute("data-section-id"));
    const quantityWidgetEl = currentContainerData.elements.quantityWidgetEl;
    const currentVariantEl = container.querySelector("[name=id]");
    if (!currentVariantEl) {
      return;
    }
    const volumePricing = container.querySelector(selectors$2.volumePricing);
    const volumePricingList = container.querySelector(selectors$2.volumePricingList);
    const volumePricingJSONEl = container.querySelector(selectors$2.volumePricingJSON);
    let quantityBreaks = null;
    if (!volumePricingJSONEl || !volumePricing) {
      return;
    }
    if (variant) {
      const volumePricingJSON = JSON.parse(volumePricingJSONEl.innerHTML);
      quantityBreaks = volumePricingJSON[variant.id].quantity_price_breaks;
      updateVariantVolumePrice(quantityBreaks);
      if (!isTrusted) {
        return;
      }
      if (quantityBreaks.length) {
        renderVolumePriceList(quantityBreaks);
        volumePricing.classList.remove(cssClasses2.hidden);
      } else {
        volumePricing.classList.add(cssClasses2.hidden);
      }
    } else {
      volumePricing.classList.add(cssClasses2.hidden);
    }
    function renderVolumePriceList(quantityBreaks2) {
      const showMoreBtn = container.querySelector(selectors$2.volumePricingShowMore);
      const moneyFormat = window.themeCore.objects.shop.money_with_currency_format;
      const priceTranslation = window.themeCore.translations.get("products.product.volume_pricing.each", {
        price: formatMoney(variant.price, moneyFormat)
      });
      showMoreBtn.addEventListener("click", function(e) {
        e.preventDefault();
        let listHiddenItems = volumePricingList.querySelectorAll(".is-hidden");
        if (!listHiddenItems.length) {
          return;
        }
        listHiddenItems.forEach(function(listItem) {
          listItem.classList.remove(cssClasses2.hidden);
        });
        showMoreBtn.classList.add(cssClasses2.hidden);
      });
      volumePricingList.innerHTML = "";
      let defaultMinPriceHTML = `
				<li class="product-volume-pricing__list-item">
					<span>${variant.quantity_rule.min}<span aria-hidden>+</span></span>
					<span>${priceTranslation}</span>
				</li>
			`;
      volumePricingList.insertAdjacentHTML("beforeend", defaultMinPriceHTML);
      quantityBreaks2.forEach(function(quantityBreak, i) {
        let hiddenClass = i >= 2 ? `${cssClasses2.hidden}` : "";
        let quantityBreakHTML = `
					<li class="product-volume-pricing__list-item ${hiddenClass}">
						<span>${quantityBreak.minimum_quantity}<span aria-hidden>+</span></span>
						<span>${quantityBreak.price_each}</span>
					</li>
				`;
        volumePricingList.insertAdjacentHTML("beforeend", quantityBreakHTML);
      });
      if (quantityBreaks2.length >= 3) {
        showMoreBtn.classList.remove(cssClasses2.hidden);
      } else {
        showMoreBtn.classList.add(cssClasses2.hidden);
      }
    }
    function updateVariantVolumePrice(quantityBreaks2) {
      const priceEls = container.querySelectorAll(selectors$2.priceVolume);
      const moneyFormat = window.themeCore.objects.shop.money_with_currency_format;
      const priceTranslation = window.themeCore.translations.get("products.product.volume_pricing.price_at_each", {
        price: formatMoney(variant.price, moneyFormat)
      });
      if (!priceEls.length) {
        return;
      }
      if (!variant) {
        priceEls.forEach((el) => el.classList.add(cssClasses2.hidden));
        return;
      }
      if (!quantityBreaks2 || !quantityBreaks2.length) {
        priceEls.forEach((el) => el.innerHTML = priceTranslation);
        priceEls.forEach((el) => el.classList.remove(cssClasses2.hidden));
        return;
      }
      const currentBreak = quantityBreaks2.findLast((qtyBreak) => {
        return Number(quantity) + Number(quantityWidgetEl.quantity.value) >= qtyBreak.minimum_quantity;
      });
      if (!currentBreak) {
        priceEls.forEach((el) => el.innerHTML = priceTranslation);
        priceEls.forEach((el) => el.classList.remove(cssClasses2.hidden));
        return;
      }
      priceEls.forEach((el) => el.innerHTML = currentBreak.price_at_each);
      priceEls.forEach((el) => el.classList.remove(cssClasses2.hidden));
    }
  }
  function getVariantCountInCart(variant) {
    const cartData = window.themeCore.cartObject;
    if (!cartData || !variant) {
      return;
    }
    if (!cartData.items.length) {
      return 0;
    }
    const currentVariant = cartData.items.find(function(item) {
      return item.variant_id === variant.id;
    });
    if (!currentVariant) {
      return 0;
    }
    return currentVariant.quantity;
  }
  function updateQuantityLabelCartCount(container, quantity) {
    if (!container) {
      return;
    }
    const priceBreaksEl = container.querySelector(selectors$2.breaksVal);
    if (!priceBreaksEl) {
      return;
    }
    priceBreaksEl.classList.toggle(cssClasses2.hidden, !quantity);
    if (!quantity) {
      priceBreaksEl.innerHTML = "";
    }
    priceBreaksEl.innerHTML = window.themeCore.translations.get("products.product.quantity_in_cart", { quantity });
  }
  async function onChangeForm({ currentTarget: targetFormElement, target, isTrusted }) {
    if (isUpdatingVariant || !target) {
      return;
    }
    // Variant id updates must not re-enter option handling
    if (target.getAttribute("name") === "id") {
      return;
    }
    const formId = target.getAttribute("form");
    let currentFormEntity = forms.find(({ form: form2 }) => {
      return form2.getAttribute("id") === formId;
    });
    // Options may sit outside <form> with form= association missing after app re-renders
    if (!currentFormEntity) {
      const closestContainer = target.closest(selectors$2.container);
      currentFormEntity = forms.find((entry) => entry.container === closestContainer);
    }
    if (!currentFormEntity) {
      return;
    }
    let sectionContainer = currentFormEntity.container;
    // Selling plan change → refresh allocation price for current variant (subscription UIs only)
    if (target.getAttribute("name") === "selling_plan") {
      const currentVariant2 = findCurrentVariant(sectionContainer) || findVariantBySelectedOptions(currentFormEntity.product, sectionContainer.querySelector(".js-product-options"));
      if (currentVariant2) {
        updatePrice(currentFormEntity.elements, currentVariant2, sectionContainer, currentFormEntity.product);
      }
      return;
    }
    if (target.hasAttribute("data-quantity-input")) {
      let currentVariant2 = findCurrentVariant(sectionContainer);
      let quantityVariantInCart = getVariantCountInCart(currentVariant2);
      updateVolumePricing(sectionContainer, currentVariant2, quantityVariantInCart, false);
      updateQuantityRules(sectionContainer, currentVariant2);
      updateQuantityLabelCartCount(sectionContainer, quantityVariantInCart);
      return;
    }
    if (!target.hasAttribute("data-option")) {
      return;
    }
    if (target.tagName === "SELECT" && target.selectedOptions.length) {
      const previouslySelected = Array.from(target.options).find((option) => option.getAttribute("selected"));
      if (previouslySelected) {
        previouslySelected.removeAttribute("selected");
      }
      target.selectedOptions[0].setAttribute("selected", "selected");
    }
    const productSection = sectionContainer;
    const sectionId = productSection.getAttribute("data-section-id");
    const productUrl = productSection.getAttribute("data-url");
    const productOptionsContainer = sectionContainer.querySelector(".js-product-options");
    if (!productOptionsContainer) {
      return;
    }
    const formIdResolved = currentFormEntity.form.getAttribute("id") || formId;
    const product = currentFormEntity.product;
    const elements = currentFormEntity.elements;
    const form = currentFormEntity.form;
    // Always resolve from live option UI first so price/id update even if section fetch fails
    let currentVariant = findVariantBySelectedOptions(product, productOptionsContainer);
    isUpdatingVariant = true;
    let html = null;
    try {
      const selectedOptionValues = getSelectedOptionValueIds(productOptionsContainer);
      if (selectedOptionValues.length > 0 && productUrl && sectionId) {
        const params = `&option_values=${selectedOptionValues.join(",")}`;
        const url = `${productUrl}?section_id=${sectionId}${params}`;
        let responseText;
        const cachedResult = cachedOptions.get(url);
        if (cachedResult) {
          responseText = cachedResult;
        } else {
          try {
            fetchController.abort();
            fetchController = new AbortController();
            responseText = await (await fetch(url, {
              signal: fetchController.signal
            })).text();
            cachedOptions.set(url, responseText);
          } catch {
            responseText = null;
          }
        }
        if (responseText) {
          prefetchOptions(sectionContainer);
          html = new DOMParser().parseFromString(responseText, "text/html");
          const nextOptions = html.querySelector(".js-product-options");
          if (nextOptions) {
            productOptionsContainer.innerHTML = nextOptions.innerHTML;
            const fromSection = findCurrentVariant(productOptionsContainer);
            if (fromSection) {
              currentVariant = fromSection;
            } else {
              currentVariant = findVariantBySelectedOptions(product, productOptionsContainer) || currentVariant;
            }
          }
          let volumePricingJSONEl = sectionContainer.querySelector(selectors$2.volumePricingJSON);
          if (volumePricingJSONEl && html.querySelector(selectors$2.volumePricingJSON)) {
            volumePricingJSONEl.innerHTML = html.querySelector(selectors$2.volumePricingJSON).innerHTML;
          }
          let productInventoryWrapper = sectionContainer.querySelector(selectors$2.productInventoryWrapper);
          if (productInventoryWrapper && html.querySelector(selectors$2.productInventoryWrapper)) {
            productInventoryWrapper.outerHTML = html.querySelector(selectors$2.productInventoryWrapper).outerHTML;
          }
        }
      }
      if (!currentVariant) {
        currentVariant = findCurrentVariant(productOptionsContainer) || findCurrentVariant(sectionContainer);
      }
      if (target.id && document.getElementById(target.id)) {
        document.getElementById(target.id).focus();
      }
      // Force UI update for real option picks (don't rely on event.isTrusted alone)
      window.themeCore.EventBus.emit(`form:${formIdResolved}:change-variant`, {
        container: sectionContainer,
        form,
        product,
        currentVariant,
        elements,
        isTrusted: true
      });
      if (currentVariant) {
        window.themeCore.EventBus.emit(`pdp:section-${sectionId}:change-variant`, {
          variantId: currentVariant.id,
          variant: currentVariant,
          product,
          firstInitialization: false
        });
        if (isEnableHistoryState(form)) {
          updateHistoryState(currentVariant);
        }
      }
    } finally {
      isUpdatingVariant = false;
    }
  }
  function validateCustomFields(arr) {
    const MINIMAL_SCROLL_OFFSET = 32;
    let error = false;
    let invalidObj = null;
    arr.forEach(function(obj) {
      const inputValue = obj.input.value.trim();
      if (obj.checkbox) {
        if (obj.checkbox.checked && !inputValue.length) {
          obj.input.classList.add("error");
          obj.checkbox.classList.remove("error");
          invalidObj = obj;
          error = true;
        } else if (!obj.checkbox.checked && inputValue.length) {
          obj.input.classList.remove("error");
          obj.checkbox.classList.add("error");
          invalidObj = obj;
          error = true;
        } else {
          obj.input.classList.remove("error");
          obj.checkbox.classList.remove("error");
        }
      }
    });
    if (invalidObj) {
      const elementY = getElementY(invalidObj.input);
      const targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight - MINIMAL_SCROLL_OFFSET : elementY - MINIMAL_SCROLL_OFFSET;
      window.scrollTo({
        top: targetY,
        behavior: "smooth"
      });
    }
    return error;
  }
  function getElementY(element) {
    return window.pageYOffset + element.getBoundingClientRect().top;
  }
  /**
   * Subscriptions app UI often lives outside <form> and/or sets selling_plan
   * on a disabled hidden input. Disabled fields are omitted from FormData, which
   * triggers: "Variant can only be purchased with a selling plan."
   */
  function ensureSellingPlanOnForm(formElement, product) {
    if (!formElement) {
      return null;
    }
    const formId = formElement.getAttribute("id");
    const container = formElement.closest(selectors$2.container) || document;
    const candidates = [
      ...formElement.querySelectorAll('[name="selling_plan"]'),
      ...document.querySelectorAll(formId ? `[name="selling_plan"][form="${formId}"]` : '[name="selling_plan"]'),
      ...container.querySelectorAll('[name="selling_plan"]')
    ];
    let planId = "";
    for (const el of candidates) {
      if ((el.type === "radio" || el.type === "checkbox") && el.checked && el.value) {
        planId = String(el.value);
        break;
      }
    }
    if (!planId) {
      for (const el of candidates) {
        if (el.type !== "radio" && el.type !== "checkbox" && el.value && !el.disabled) {
          planId = String(el.value);
          break;
        }
      }
    }
    if (!planId) {
      const appChecked = container.querySelector(
        'input[id^="selling_plan_"]:checked, input[id*="selling-plan"]:checked, [class*="shopify_subscriptions"] input[name="selling_plan"]:checked, [class*="shopify-subscription"] input[name="selling_plan"]:checked'
      );
      if (appChecked && appChecked.value) {
        planId = String(appChecked.value);
      }
    }
    // OTP selected → never submit a plan on mixed products
    const otpChecked = container.querySelector('[id^="tab_otp_"]:checked');
    if (otpChecked) {
      planId = "";
    }
    let formInput = formElement.querySelector('input[name="selling_plan"]:not([type="radio"]):not([type="checkbox"])');
    // Do not inject selling_plan on normal products unless a plan was actually selected
    if (!formInput && !planId && !productRequiresSellingPlan(product, null)) {
      return null;
    }
    if (!formInput) {
      formInput = document.createElement("input");
      formInput.type = "hidden";
      formInput.name = "selling_plan";
      formElement.appendChild(formInput);
    }
    if (planId) {
      formInput.value = planId;
      formInput.disabled = false;
      formInput.removeAttribute("disabled");
    } else {
      formInput.value = "";
      formInput.disabled = true;
    }
    return planId || null;
  }
  function onFormSubmit(event) {
    const target = event.target;
    event.preventDefault();
    const form = forms.find((f) => f.id === target.getAttribute(attributes.id));
    if (!form) {
      return;
    }
    const customFieldElementsArr = form.elements.customFieldElements;
    if (customFieldElementsArr) {
      let isError = validateCustomFields(customFieldElementsArr);
      if (isError) {
        return;
      }
    }
    if (form) {
      const { submit } = form.elements;
      submit.forEach((button) => button.classList.add(classes.loading));
    }
    const planId = ensureSellingPlanOnForm(target, form.product);
    const formData = new FormData(target);
    const serialized = convertFormData(formData);
    if (planId) {
      // Cart API expects numeric selling_plan id
      const planNum = parseInt(planId, 10);
      serialized.selling_plan = Number.isNaN(planNum) ? planId : planNum;
    } else if (Object.prototype.hasOwnProperty.call(serialized, "selling_plan")) {
      delete serialized.selling_plan;
    }
    // id must be a number for Cart API
    if (serialized.id != null) {
      const idNum = parseInt(serialized.id, 10);
      if (!Number.isNaN(idNum)) {
        serialized.id = idNum;
      }
    }
    window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.ADD_TO_CART, serialized).then((response) => {
      onFormSubmitSuccess(response, form);
    }).catch((error) => {
      onFormSubmitError(error, form);
    });
  }
  function onFormSubmitSuccess(success, form) {
    if (!form) {
      return;
    }
    const formElement = form.container;
    const { quantityWidget, submit } = form.elements;
    quantityWidget && quantityWidget.setValue(0);
    submit.forEach((button) => button.classList.remove(classes.loading));
    resetRecipientForm(formElement);
    window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.GET_CART);
  }
  function onFormSubmitError(error, form) {
    if (!form) {
      return;
    }
    const formElement = form.container;
    const hasRecipientForm = formElement.querySelector(selectors$2.recipientCheckbox);
    let { description } = error;
    const { quantityError, submit } = form.elements;
    if (typeof description === "object" && hasRecipientForm) {
      const sectionID = form.container.dataset.sectionId;
      let errors = error.errors;
      const errorMessages = formElement.querySelectorAll(selectors$2.formError);
      const recipientFormFields = formElement.querySelectorAll(selectors$2.recipientField);
      if (errorMessages.length && recipientFormFields.length) {
        errorMessages.forEach(function(messageEl) {
          messageEl.classList.add(classes.hidden);
          messageEl.innerText = "";
        });
        recipientFormFields.forEach(function(field) {
          field.setAttribute("aria-invalid", false);
          field.removeAttribute("aria-describedby");
        });
      }
      return Object.entries(errors).forEach(([key, value]) => {
        const errorMessageId = `RecipientForm-${key}-error-${sectionID}`;
        const errorMessageElement = formElement.querySelector(`#${errorMessageId}`);
        const inputId = `Recipient-${key}-${sectionID}`;
        const inputElement = formElement.querySelector(`#${inputId}`);
        let message = `${value.join(", ")}`;
        if (key === "send_on") {
          message = `${value.join(", ")}`;
        }
        if (errorMessageElement) {
          errorMessageElement.innerText = message;
          errorMessageElement.classList.remove(classes.hidden);
        }
        if (inputElement) {
          inputElement.setAttribute("aria-invalid", true);
          inputElement.setAttribute("aria-describedby", errorMessageId);
        }
        submit.forEach((button) => button.classList.remove(classes.loading));
      });
    }
    quantityError && (quantityError.innerHTML = description);
    submit.forEach((button) => button.classList.remove(classes.loading));
  }
  function findCurrentVariant(container) {
    if (!container) {
      return;
    }
    const variantJSONElement = container.querySelector(selectors$2.variantElemJSON);
    const currentVariant = !!variantJSONElement ? JSON.parse(variantJSONElement.innerHTML) : null;
    return currentVariant;
  }
  function updateHistoryState(variant) {
    if (!variant) {
      return null;
    }
    const url = getUrlWithVariant(window.location.href, variant.id);
    window.history.replaceState({ path: url }, "", url);
  }
  function isEnableHistoryState(form) {
    return form.dataset.enableHistoryState || false;
  }
  function initFirstState() {
    forms.forEach(async (form) => {
      let currentVariant = findCurrentVariant(form.container);
      updateForm({ currentVariant, elements: form.elements, container: form.container, product: form.product, isTrusted: true });
      if (currentVariant) {
        const productSection = form.container.closest("[data-section-type=product]");
        const sectionId = productSection.getAttribute("data-section-id");
        window.themeCore.EventBus.emit(`pdp:section-${sectionId}:change-variant`, {
          variantId: currentVariant.id,
          variant: currentVariant,
          product: form.product,
          firstInitialization: true
        });
      }
      if (isEnableHistoryState(form.form)) {
        updateHistoryState(currentVariant);
      }
      await prefetchOptions(form.container);
    });
  }
  function findContainers() {
    return [...document.querySelectorAll(selectors$2.container)];
  }
  function setForms() {
    return containers.reduce((acc, container) => {
      const productJsonTag = container.querySelector(selectors$2.product);
      const form = container.querySelector(selectors$2.form);
      let product = {};
      try {
        product = JSON.parse(productJsonTag.innerHTML);
      } catch (e) {
        return acc;
      }
      const findFormSubmitButtons = () => {
        return [...container.querySelectorAll(selectors$2.submit)].filter((button) => {
          const isInsideForm = button.closest(selectors$2.form);
          const buttonForm = button.getAttribute("form");
          const formId = form.getAttribute("id");
          return isInsideForm || buttonForm === formId;
        });
      };
      const id = form.getAttribute(attributes.id);
      const submit = findFormSubmitButtons();
      const skuContainer = container.querySelector(selectors$2.sku);
      const priceContainers = [...container.querySelectorAll(selectors$2.price)];
      const quantityError = container.querySelector(selectors$2.quantityError);
      const variantIdContainers = [...container.querySelectorAll(selectors$2.variantId)];
      let optionElements = [...container.querySelectorAll("[data-option]")];
      let mobileSkuContainer = null;
      const quantityWidgetEl = QuantityWidget(container, {
        onQuantityChange: (widget) => {
          updateErrorMessages({ quantityError });
        }
      }).init();
      const customFieldBlocks = [...container.querySelectorAll(selectors$2.customFieldGroup)];
      const customFieldElements = customFieldBlocks.map(function(customFieldBlock) {
        let input = customFieldBlock.querySelector(selectors$2.customFieldInput);
        let checkbox = customFieldBlock.querySelector(selectors$2.customFieldCheckbox);
        return {
          input,
          checkbox
        };
      });
      return [
        ...acc,
        {
          id,
          container,
          form,
          product,
          elements: {
            skuContainer,
            priceContainers,
            quantityWidgetEl,
            quantityError,
            variantIdContainers,
            submit,
            mobileSkuContainer,
            optionElements,
            customFieldElements
          }
        }
      ];
    }, []);
  }
  function initStickyBar() {
    containers.forEach((container) => {
      const stickyBar = container.querySelector(selectors$2.stickyBar);
      const mainButton = container.querySelector(selectors$2.submit);
      if (!stickyBar || !mainButton) {
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const rect = mainButton.getBoundingClientRect();
          stickyBar.classList.toggle(window.themeCore.utils.cssClasses.active, !entry.isIntersecting && rect.bottom < 0);
          if (!entry.isIntersecting) {
            const animate = stickyBar.closest(selectors$2.animate);
            animate && animate.classList.remove(classes.animate);
            animate && animate.classList.add(classes.animated);
          }
        });
      }, {});
      observer.observe(mainButton);
      stickyBar.addEventListener("click", (event) => {
        const stickyBarButton = event.target.closest(selectors$2.stickyBarButton);
        if (!stickyBarButton) {
          return;
        }
        mainButton.focus();
      });
    });
  }
  function initRecipientForm() {
    containers.forEach((container) => {
      const recipientCheckbox = container.querySelector(selectors$2.recipientCheckbox);
      const recipientFormFieldsContainer = container.querySelector(selectors$2.recipientFieldsContainer);
      const recipientFormFields = container.querySelectorAll(selectors$2.recipientField);
      const recipientTimeZoneOffset = container.querySelector(selectors$2.recipientTimeZoneOffset);
      const recipientControlNoJsCheckbox = container.querySelector(selectors$2.recipientNoJsControl);
      if (!recipientCheckbox || !recipientFormFieldsContainer || !recipientFormFields || !recipientTimeZoneOffset) {
        return;
      }
      recipientTimeZoneOffset.value = (/* @__PURE__ */ new Date()).getTimezoneOffset().toString();
      recipientControlNoJsCheckbox.disabled = true;
      recipientCheckbox.disabled = false;
      disableInputFields();
      recipientCheckbox.addEventListener("change", function() {
        if (recipientCheckbox.checked) {
          recipientFormFieldsContainer.classList.remove(classes.hidden);
          enableInputFields();
        } else {
          recipientFormFieldsContainer.classList.add(classes.hidden);
          disableInputFields();
        }
      });
      function disableInputFields() {
        recipientFormFields.forEach(function(field) {
          field.disabled = true;
        });
        recipientTimeZoneOffset.disabled = true;
      }
      function enableInputFields() {
        recipientFormFields.forEach(function(field) {
          field.disabled = false;
        });
        recipientTimeZoneOffset.disabled = false;
      }
    });
  }
  function recipientFormClearErrors(form) {
    const recipientCheckbox = form.querySelector(selectors$2.recipientCheckbox);
    if (!recipientCheckbox) {
      return;
    }
    const recipientFormFieldsContainer = form.querySelector(selectors$2.recipientFieldsContainer);
    const errorMessages = recipientFormFieldsContainer.querySelectorAll(selectors$2.formError);
    const recipientFormFields = form.querySelectorAll(selectors$2.recipientField);
    if (!errorMessages || !recipientFormFields) {
      return;
    }
    errorMessages.forEach(function(messageEl) {
      messageEl.classList.add(classes.hidden);
      messageEl.innerText = "";
    });
    recipientFormFields.forEach(function(field) {
      field.setAttribute("aria-invalid", false);
      field.removeAttribute("aria-describedby");
    });
  }
  function recipientFormClearInputs(form) {
    const recipientCheckbox = form.querySelector(selectors$2.recipientCheckbox);
    if (!recipientCheckbox) {
      return;
    }
    const recipientFormFields = form.querySelectorAll(selectors$2.recipientField);
    if (!recipientFormFields) {
      return;
    }
    recipientFormFields.forEach(function(field) {
      field.value = "";
    });
  }
  function resetRecipientForm(form) {
    const recipientCheckbox = form.querySelector(selectors$2.recipientCheckbox);
    if (!recipientCheckbox) {
      return;
    }
    if (recipientCheckbox.checked) {
      recipientCheckbox.checked = false;
      recipientCheckbox.dispatchEvent(new Event("change"));
      recipientFormClearErrors(form);
      recipientFormClearInputs(form);
    }
  }
  function showOptions() {
    containers.forEach((form) => {
      const variants = form.querySelector(selectors$2.variants);
      if (variants && variants.dataset.jsProductVariant !== "no-hidden") {
        variants.classList.add(cssClasses2.hidden);
      }
    });
  }
  function transformOptionsToVariants(options) {
    const groupedOptions = options.reduce((acc, option) => {
      if (!acc[option.name]) {
        acc[option.name] = [];
      }
      acc[option.name].push(option);
      return acc;
    }, {});
    const optionTypes = Object.values(groupedOptions);
    function cartesianProduct(arrays) {
      return arrays.reduce((acc, curr) => {
        const result = [];
        acc.forEach((a) => {
          curr.forEach((c) => {
            result.push([...a, c]);
          });
        });
        return result;
      }, [[]]);
    }
    const combinations = cartesianProduct(optionTypes);
    const variants = combinations.map((combination) => {
      return {
        option_values: combination.map((opt) => opt.value).join(","),
        selected: combination.every((opt) => opt.selected),
        options: combination
      };
    });
    return variants;
  }
  function sortVariantsByProximity(variants) {
    const selectedVariant = variants.find((v) => v.selected);
    if (!selectedVariant) {
      return variants;
    }
    const selectedValues = selectedVariant.options.map((opt) => opt.value);
    return variants.sort((a, b) => {
      const aMatches = a.options.filter((opt) => selectedValues.includes(opt.value)).length;
      const bMatches = b.options.filter((opt) => selectedValues.includes(opt.value)).length;
      const aDistance = selectedValues.length - aMatches;
      const bDistance = selectedValues.length - bMatches;
      if (aDistance !== bDistance) {
        return aDistance - bDistance;
      }
      return 0;
    });
  }
  async function fetchUrl(url) {
    const response = await fetch(url, {
      signal: prefetchController.signal
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.text();
  }
  async function prefetchOptions(form) {
    const productOptionsContainer = form.querySelector(".js-product-options");
    if (!productOptionsContainer) {
      return;
    }
    const productSection = form.closest("[data-section-type=product]");
    const sectionId = productSection.getAttribute("data-section-id");
    const productUrl = productSection.getAttribute("data-url");
    const allOptions = Array.from(
      productOptionsContainer.querySelectorAll("select[data-option] option, input[data-option]")
    ).map((item) => {
      var _a, _b;
      return {
        name: item.dataset.option || ((_b = (_a = item.closest("select")) == null ? void 0 : _a.dataset) == null ? void 0 : _b.option),
        value: item.dataset.optionValueId,
        selected: item.matches("[selected], :checked")
      };
    });
    const variants = transformOptionsToVariants(allOptions);
    const sortedVariants = sortVariantsByProximity(variants);
    const filteredVariants = sortedVariants.filter((variant) => !Array.from(cachedOptions.keys()).some((key) => key.includes(variant.option_values)));
    const variantsToFetch = filteredVariants.slice(0, 20);
    const urlsToFetch = variantsToFetch.map(({ option_values }) => `${productUrl}?section_id=${sectionId}&option_values=${option_values}`);
    prefetchController.abort();
    prefetchController = new AbortController();
    const fetchPromises = urlsToFetch.map((url) => fetchUrl(url));
    const results = await Promise.allSettled(fetchPromises);
    results.forEach((result, index) => {
      if (result.status === "fulfilled") {
        const url = urlsToFetch[index];
        cachedOptions.set(url, result.value);
      }
    });
  }
  function allForms() {
    return forms;
  }
  return Object.freeze({
    init: init2,
    allForms
  });
};
const selectors$1 = {
  container: "[data-zoom-container]",
  media: "[data-zoom-media]",
  modal: "[data-zoom-modal]",
  toggle: "[data-zoom-modal-toggle]",
  content: "[data-zoom-content]",
  slider: "[data-zoom-slider]",
  slide: "[data-zoom-slide]",
  modalMedia: ".js-zoom-slider-modal-media",
  prevSlide: ".swiper-button-prev",
  nextSlide: ".swiper-button-next",
  button: "[data-js-zoom-button]",
  productSlider: "[data-js-product-media-slider]",
  productSliderWrapper: ".swiper-wrapper",
  notInitedIframe: ".js-video.js-video-youtube, .js-video:empty"
};
const breakpoints = {
  afterMedium: 1200
};
const Zoom = (context = document) => {
  const Swiper = window.themeCore.utils.Swiper;
  const off = window.themeCore.utils.off;
  const on = window.themeCore.utils.on;
  const Toggle2 = window.themeCore.utils.Toggle;
  const VIDEO_TYPES = window.themeCore.utils.VIDEO_TYPES;
  const Video2 = window.themeCore.utils.Video;
  const globalClasses = {
    ...window.themeCore.utils.cssClasses,
    isDragging: "is-dragging"
  };
  let containers = null;
  let isDrag = false;
  let lastZoomOpenAt = 0;
  function portModalToBody(container) {
    if (container.modalEl && container.modalEl.parentElement !== document.body) {
      document.body.appendChild(container.modalEl);
    }
  }
  async function init2() {
    containers = getContainers();
    containers.forEach((container) => {
      if (!container.media.length || !container.modalEl) {
        return;
      }
      container.modal.init();
      initVideos2(container);
      container.slider = initMediaSlider(container);
      portModalToBody(container);
      const observer = new MutationObserver(() => {
        if (container.el.querySelector(selectors$1.notInitedIframe)) {
          return;
        }
        disableTabulationOnNotActiveSlidesWithModel(container.slider);
        observer.disconnect();
      });
      const observerOptions = {
        attributes: true,
        childList: true,
        subtree: true
      };
      observer.observe(container.el, observerOptions);
      zoomMove(container);
    });
    setEventListeners();
  }
  function zoomMove(container) {
    let pos = { top: 0, left: 0, x: 0, y: 0 };
    const setDraggingCursor = (isDragging) => {
      if (!container.sliderEl)
        return;
      container.sliderEl.classList.toggle(globalClasses.isDragging, isDragging);
    };
    const mouseDownHandler = function(e) {
      if (window.innerWidth < breakpoints.afterMedium) {
        return;
      }
      isDrag = false;
      pos = {
        x: e.clientX,
        y: e.clientY
      };
      on("mousemove", document, mouseMoveHandler);
      on("mouseup", document, mouseUpHandler);
    };
    const mouseMoveHandler = function(e) {
      const dx = e.clientX - pos.x;
      const dy = e.clientY - pos.y;
      const DRAG_THRESHOLD = 3;
      if (Math.abs(dx) + Math.abs(dy) > DRAG_THRESHOLD) {
        isDrag = true;
      }
    };
    const mouseUpHandler = function() {
      off("mousemove", document, mouseMoveHandler);
      off("mouseup", document, mouseUpHandler);
      setDraggingCursor(false);
    };
    on("mousedown", container.el, mouseDownHandler);
    on("dragstart", container.el, (e) => {
      const target = e.target;
      if (target && target.tagName === "IMG" && target.closest(selectors$1.slider)) {
        e.preventDefault();
      }
    });
    on("mousedown", container.el, (e) => {
      if (window.innerWidth < breakpoints.afterMedium || e.button !== 0)
        return;
      const target = e.target;
      const isImage = target && target.tagName === "IMG" && target.closest(selectors$1.slider);
      const isZoomed = container.slider && container.slider.zoom && container.slider.zoom.scale > 1;
      if (isImage && isZoomed) {
        e.preventDefault();
        setDraggingCursor(true);
      }
    });
  }
  function setEventListeners() {
    containers.forEach((container) => {
      if (!container.modalEl) {
        return;
      }
      on("click", container.el, (e) => onTriggerClick(e, container));
      on("click", container.el, (e) => onSlideClick(e, container));
      on("click", container.el, (e) => onButtonClick(e, container));
      on("click", container.modalEl, (e) => onModalBackdropClick(e, container));
      window.themeCore.EventBus.listen(
        `Toggle:${container.modalEl.id}:close`,
        (e) => onZoomModalClose(e, container)
      );
    });
  }
  function onModalBackdropClick(event, container) {
    if (!container.modal || !container.modalEl) {
      return;
    }
    if (Date.now() - lastZoomOpenAt < 500) {
      return;
    }
    if (event.target.closest(
      "img, video, button, model-viewer, iframe, .zoom-slider__media, .swiper-button-next, .swiper-button-prev, [data-zoom-modal-toggle]"
    )) {
      return;
    }
    container.modal.close(container.modalEl);
  }
  function getContainers() {
    return [...context.querySelectorAll(selectors$1.container)].map(
      (container) => {
        const media = [...container.querySelectorAll(selectors$1.media)];
        const button = container.querySelector(selectors$1.button);
        const modalId = container.getAttribute("data-zoom-modal-id");
        const modalEl = container.querySelector(selectors$1.modal) || (modalId && document.getElementById(modalId)) || null;
        const slides = modalEl ? [...modalEl.querySelectorAll(selectors$1.slide)] : [...container.querySelectorAll(selectors$1.slide)];
        const content = modalEl ? modalEl.querySelector(selectors$1.content) : container.querySelector(selectors$1.content);
        const sliderEl = modalEl ? modalEl.querySelector(selectors$1.slider) : container.querySelector(selectors$1.slider);
        if (!modalEl) {
          return {
            el: container,
            sliderEl,
            slides,
            modalEl: null,
            modal: null,
            media,
            content,
            button
          };
        }
        const modal = Toggle2({
          toggleSelector: modalEl.id
        });
        return {
          el: container,
          sliderEl,
          slides,
          modalEl,
          modal,
          media,
          content,
          button
        };
      }
    );
  }
  function initVideos2({ slides }) {
    slides.forEach((slide) => {
      const videosOnSlide = Video2({
        videoContainer: slide,
        options: {
          youtube: {
            controls: 1,
            showinfo: 1
          }
        }
      }).init();
      const video = Array.isArray(videosOnSlide) ? videosOnSlide[0] : null;
      if (video) {
        slide.video = video;
      }
    });
  }
  function initMediaSlider({ sliderEl, slides }) {
    return new Swiper(sliderEl, {
      slidesPerView: 1,
      allowTouchMove: false,
      zoom: {
        maxRatio: 3,
        minRatio: 1
      },
      navigation: {
        prevEl: selectors$1.prevSlide,
        nextEl: selectors$1.nextSlide
      },
      on: {
        beforeSlideChangeStart: function(slider) {
          if (slider && slider.zoom && typeof slider.zoom.out === "function") {
            slider.zoom.out();
          }
        },
        slideChange: function(swiper) {
          pauseAllVideos(slides);
          disableTabulationOnNotActiveSlidesWithModel(swiper);
        }
      }
    });
  }
  function pauseAllVideos(slides) {
    const videoSlides = slides.filter((slide) => slide.video);
    if (!videoSlides.length) {
      return;
    }
    videoSlides.forEach(({ video }) => {
      if (VIDEO_TYPES.youtube === video.type) {
        video.player.pauseVideo();
      } else {
        video.player.pause();
      }
    });
  }
  function openZoom(container, index) {
    if (!container.modal || !container.modalEl) {
      return;
    }
    lastZoomOpenAt = Date.now();
    portModalToBody(container);
    removeLoaded(container.modalEl);
    document.querySelector(":root").style.setProperty("--page-height", `${window.innerHeight}px`);
    container.modal.open(container.modalEl);
    try {
      if (container.slider) {
        container.slider.slideTo(index >= 0 ? index : 0, 0);
        if (typeof container.slider.update === "function") {
          container.slider.update();
        }
        disableTabulationOnNotActiveSlidesWithModel(container.slider);
      }
    } catch (err) {
    }
    window.themeCore.EventBus.emit("product:zoom:open");
  }
  function onTriggerClick(event, container) {
    const media = event.target.closest(selectors$1.media);
    if (!media || !container.media.length) {
      return;
    }
    const mediaId = media.dataset.zoomMedia;
    const index = container.slides.findIndex(
      (slide) => slide.dataset.zoomSlide === mediaId
    );
    openZoom(container, index);
  }
  function onSlideClick(event, container) {
    const slide = event.target.closest(selectors$1.slide);
    if (!slide || isDrag) {
      isDrag = false;
      return;
    }
    if (container.slider && container.slider.zoom) {
      container.slider.zoom.toggle();
    }
  }
  function onButtonClick(event, container) {
    const button = event.target.closest(selectors$1.button);
    if (!button) {
      return;
    }
    const galleryLayout = container.el.dataset.mediaLayout;
    const productSlider = container.el.querySelector(
      selectors$1.productSlider
    );
    if (!productSlider) {
      return;
    }
    let media = null;
    switch (galleryLayout) {
      case "carousel":
        media = productSlider.querySelector(".swiper-slide-active");
        break;
      case "stacked":
      case "stacked_2_col":
      case "stacked_2_col_with_big_image":
      default:
        media = [...productSlider.querySelectorAll(".swiper-slide")][0];
        break;
    }
    if (!media || !container.media.length) {
      return;
    }
    const mediaId = media.dataset.zoomMedia || media.dataset.zoomMediaHtmlVideo;
    const index = container.slides.findIndex(
      (slide) => slide.dataset.zoomSlide === mediaId
    );
    openZoom(container, index);
  }
  function removeLoaded(modal) {
    if (!modal) {
      return;
    }
    const modalMedias = modal.querySelectorAll(selectors$1.modalMedia);
    if (modalMedias.length < 1) {
      return;
    }
    modalMedias.forEach((modalMedia) => {
      if (modalMedia.classList.contains(globalClasses.loading)) {
        if (!modalMedia.complete) {
          modalMedia.addEventListener("load", () => {
            modalMedia.classList.remove(globalClasses.loading);
          });
        } else {
          modalMedia.classList.remove(globalClasses.loading);
        }
      }
    });
  }
  function onZoomModalClose(event, container) {
    if (!event) {
      return;
    }
    if (container.slider && container.slider.zoom && typeof container.slider.zoom.out === "function") {
      container.slider.zoom.out();
    }
    pauseAllVideos(container.slides);
  }
  return Object.freeze({
    init: init2
  });
};
const ProductCarousel = ({ config, selectors: selectors2, sectionId }) => {
  const Swiper = window.themeCore.utils.Swiper;
  const extendDefaults = window.themeCore.utils.extendDefaults;
  const defaultSelectors = {
    slider: ".js-product-media-slider",
    sliderNavigationNext: ".js-product-media-slider-next",
    sliderNavigationPrev: ".js-product-media-slider-prev",
    thumbNavigationNext: ".js-product-media-thumb-next",
    thumbNavigationPrev: ".js-product-media-thumb-prev",
    sliderSlideVariantId: ".js-product-gallery-slide-variant",
    sliderThumbnails: ".js-product-media-slider-thumbnails",
    sliderPagination: ".product-media__slider-pagination",
    activeClass: ".swiper-slide-active",
    modelPoster: ".js-product-media-model-poster",
    notInitedIframe: ".js-video.js-video-youtube, .js-video:empty"
  };
  selectors2 = extendDefaults(defaultSelectors, selectors2);
  let Slider = null;
  let Thumbnails = null;
  let initiated = false;
  let firstLoad = true;
  function init2() {
    if (initiated) {
      return Slider;
    }
    const mainSlider = document.querySelector(selectors2.slider);
    const sliderThumbnails = document.querySelector(selectors2.sliderThumbnails);
    let sliderAutoHeight = mainSlider.dataset.autoHeight;
    const thumbnailsPosition = sliderThumbnails.dataset.thumbnailsPosition;
    let thumbnailsDirections = "horizontal";
    if (thumbnailsPosition === "left") {
      thumbnailsDirections = "vertical";
    }
    if (thumbnailsDirections === "horizontal") {
      Thumbnails = new Swiper(selectors2.sliderThumbnails, {
        direction: thumbnailsDirections,
        slidesPerView: 5,
        spaceBetween: 16,
        freeMode: true,
        watchSlidesProgress: true,
        a11y: {
          slideRole: ""
        },
        threshold: 10
      });
    } else {
      Thumbnails = new Swiper(selectors2.sliderThumbnails, {
        direction: "horizontal",
        slidesPerView: 5,
        spaceBetween: 16,
        freeMode: true,
        watchSlidesProgress: true,
        threshold: 10,
        breakpoints: {
          1200: {
            slidesPerView: 4,
            spaceBetween: 10,
            direction: thumbnailsDirections
          }
        }
      });
    }
    Thumbnails.$el.on("keydown", (e) => {
      if (e.keyCode !== 13 && e.keyCode !== 32) {
        return;
      }
      const slideIndex = e.target.dataset.slideIndex;
      if (!slideIndex)
        return;
      Thumbnails.slideTo(slideIndex);
      Slider.slideTo(slideIndex);
    });
    let prevArrow = document.querySelector(selectors2.sliderNavigationPrev);
    let nextArrow = document.querySelector(selectors2.sliderNavigationNext);
    let dynamicPagination = document.querySelector(selectors2.slider).getAttribute("data-dynamic-pagination");
    dynamicPagination = dynamicPagination === "true";
    sliderAutoHeight = sliderAutoHeight === "true";
    Slider = new Swiper(selectors2.slider, {
      ...config,
      autoHeight: sliderAutoHeight,
      spaceBetween: 8,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow
      },
      pagination: {
        el: selectors2.sliderPagination,
        clickable: true,
        dynamicBullets: dynamicPagination
      },
      thumbs: {
        swiper: Thumbnails
      }
    });
    let thumbPrevButton = document.querySelector(selectors2.thumbNavigationPrev);
    let thumbNextButton = document.querySelector(selectors2.thumbNavigationNext);
    if (thumbnailsDirections === "vertical" && thumbPrevButton && thumbNextButton) {
      Slider.on("slideChange", function() {
        if (this.activeIndex === 0) {
          thumbPrevButton.setAttribute("disabled", "");
          thumbPrevButton.classList.add("swiper-button-disabled");
        } else {
          thumbPrevButton.removeAttribute("disabled");
          thumbPrevButton.classList.remove("swiper-button-disabled");
        }
        if (this.slides.length - 1 === this.activeIndex) {
          thumbNextButton.setAttribute("disabled", "");
          thumbNextButton.classList.add("swiper-button-disabled");
        } else {
          thumbNextButton.removeAttribute("disabled", "");
          thumbNextButton.classList.remove("swiper-button-disabled");
        }
      });
      thumbPrevButton.addEventListener("click", function() {
        Slider.slidePrev();
      });
      thumbNextButton.addEventListener("click", function() {
        Slider.slideNext();
      });
    }
    Slider.on("slideChange", function(swiper) {
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) {
        return;
      }
      swiper.allowTouchMove = !(activeSlide.hasAttribute("data-model-slide") && !activeSlide.querySelector(selectors2.modelPoster));
    });
    const targetNode = document.querySelector(selectors2.slider);
    const observer = new MutationObserver(() => {
      if (targetNode.querySelector(selectors2.notInitedIframe)) {
        return;
      }
      disableTabulationOnNotActiveSlidesWithModel(Slider);
      observer.disconnect();
    });
    const observerOptions = {
      attributes: true,
      childList: true,
      subtree: true
    };
    observer.observe(targetNode, observerOptions);
    setEventBusListeners2();
    initiated = true;
  }
  function setEventBusListeners2() {
    if (!Slider) {
      return;
    }
    Slider.on("slideChange", function(swiper) {
      window.themeCore.EventBus.emit("product-slider:slide-change");
      disableTabulationOnNotActiveSlidesWithModel(swiper);
    });
    window.themeCore.EventBus.listen(`pdp:section-${sectionId}:change-variant`, onChangeVariant);
  }
  function onChangeVariant({ variant }) {
    if (!Slider) {
      return;
    }
    let variantMediaID = null;
    if (variant.featured_media) {
      variantMediaID = variant.featured_media.id;
    }
    const currentIndex = [...Slider.slides].findIndex((slide) => {
      const slideVariantIdEl = slide.querySelector(selectors2.sliderSlideVariantId);
      if (!slideVariantIdEl) {
        return false;
      }
      const slideMediaId = slideVariantIdEl.getAttribute("data-media-id");
      return slideMediaId.includes(variantMediaID);
    });
    if (currentIndex === false || currentIndex === -1) {
      return;
    }
    const isShowFirstMediaImage = Slider.el.hasAttribute("data-is-show-first-media-image");
    if (firstLoad && isShowFirstMediaImage) {
      firstLoad = false;
      return;
    }
    Slider.slideTo(currentIndex);
  }
  function destroy() {
    if (Slider && initiated) {
      Slider.destroy();
      Slider = null;
    }
    if (Thumbnails && initiated) {
      Thumbnails.destroy();
      Thumbnails = null;
    }
    initiated = false;
  }
  function disableSwipe() {
    if (!Slider) {
      return;
    }
    Slider.allowTouchMove = false;
  }
  return Object.freeze({
    init: init2,
    destroy,
    disableSwipe
  });
};
const ProductStickyForm = (section) => {
  const on = window.themeCore.utils.on;
  const DEFAULT_HEADER_HEIGHT = 1;
  const STICKY_SCROLL_KOEFICIENT = 100;
  const selectors2 = {
    stickyContainer: ".js-product-sticky-container:not(.product-media__container)",
    headerContentWrapper: "[data-header-container]",
    headerSticky: "[data-header-sticky]",
    cssRoot: ":root"
  };
  const cssVariables = {
    headerHeightStatic: "--header-height-static"
  };
  const breakpoints2 = {
    afterMedium: 1200
  };
  const stickyContainers = [
    ...section.querySelectorAll(selectors2.stickyContainer)
  ];
  const cssRoot = document.querySelector(selectors2.cssRoot);
  let headerHeight = getHeaderHeight();
  let windowHeight = window.innerHeight;
  let oldScrollPosition = window.scrollY;
  function getHeaderHeight() {
    const header = document.querySelector(selectors2.headerContentWrapper);
    if (!header) {
      return DEFAULT_HEADER_HEIGHT;
    }
    const isHeaderSticky = header.closest(selectors2.headerSticky);
    if (!isHeaderSticky) {
      return DEFAULT_HEADER_HEIGHT;
    }
    const headerHeightStaticValue = cssRoot.style.getPropertyValue(cssVariables.headerHeightStatic);
    return headerHeightStaticValue ? parseInt(headerHeightStaticValue) : DEFAULT_HEADER_HEIGHT;
  }
  function init2() {
    // Dual-column PDP strips .js-product-sticky-container — often no targets.
    // Never use reduce() here (empty array throws and breaks the product page).
    if (!stickyContainers || !stickyContainers.length) {
      return;
    }
    let smallerContainer = stickyContainers[0];
    for (let i = 1; i < stickyContainers.length; i++) {
      const container = stickyContainers[i];
      if (container.offsetHeight < smallerContainer.offsetHeight) {
        smallerContainer = container;
      }
    }
    initStickyContainer(smallerContainer);
  }
  function initStickyContainer(container) {
    if (!container || !section) {
      return;
    }
    container.style.top = headerHeight + "px";
    on("scroll", () => {
      onScroll(container);
    });
  }
  function onScroll(container) {
    if (window.innerWidth < breakpoints2.afterMedium) {
      return;
    }
    headerHeight = getHeaderHeight();
    let containerHeight = container.getBoundingClientRect().height || 0;
    let differentHeights = windowHeight - containerHeight + headerHeight;
    setTimeout(() => {
      let currentScrollPosition = window.scrollY;
      windowHeight = window.innerHeight;
      containerHeight = container.getBoundingClientRect().height || 0;
      if (differentHeights < headerHeight) {
        if (oldScrollPosition > differentHeights) {
          section.style.top = `${windowHeight - containerHeight}px`;
        } else {
          section.style.top = `${oldScrollPosition}px`;
        }
      }
      if (currentScrollPosition > oldScrollPosition) {
        let containerTopPosition = parseInt(
          container.style.top.replace("px", "")
        );
        if (!containerTopPosition) {
          return;
        }
        if (containerTopPosition > windowHeight - containerHeight - Math.ceil(
          container.clientHeight / STICKY_SCROLL_KOEFICIENT
        )) {
          container.style.top = `${containerTopPosition - Math.ceil(
            container.clientHeight / STICKY_SCROLL_KOEFICIENT
          )}px`;
        }
      } else if (currentScrollPosition < oldScrollPosition) {
        let containerTopPosition = parseInt(
          container.style.top.replace("px", "")
        );
        if (!containerTopPosition) {
          return;
        }
        if (containerTopPosition < headerHeight) {
          container.style.top = `${containerTopPosition + Math.ceil(
            container.clientHeight / STICKY_SCROLL_KOEFICIENT
          )}px`;
        }
      }
      oldScrollPosition = window.scrollY;
    }, 0);
  }
  return Object.freeze({
    init: init2
  });
};
const ProductNotifyMe = (section) => {
  const sectionId = section && section.dataset.sectionId;
  const selectors2 = {
    notifyMeButtonWrapper: ".js-notify-me-button-wrapper",
    notifyMeButton: ".js-notify-me-button",
    notifyMePopup: ".js-notify-me-popup",
    notifyMeForm: ".js-notify-me-form",
    notifyMeFormStatus: ".js-notify-me-form-status",
    notifyMeFormInputMessage: "[name='contact[message]']",
    notifyMeFormInputProductURL: "[name='contact[ProductURL]']"
  };
  const placeholders = {
    productTitle: "{{ product_title }}"
  };
  const cssClasses2 = {
    active: "is-active",
    hidden: "is-hidden",
    isPosted: "is-posted",
    isNotifyMeActive: "is-notify-me-popup-active"
  };
  const searchParams = {
    contactPosted: "contact_posted",
    contactProductUrl: "contact[ProductURL]",
    contactMessage: "contact[message]",
    formType: "form_type"
  };
  const Toggle2 = window.themeCore.utils.Toggle;
  const on = window.themeCore.utils.on;
  let notifyMeButtonWrapper = null;
  let notifyMeButton = null;
  let notifyMePopup = null;
  let notifyMeForm = null;
  let notifyMeFormInputMessage = null;
  let notifyMeFormInputProductURL = null;
  let notifyMePopupToggle = null;
  let notifyMeFormStatus = null;
  let notifyMeFormId = null;
  let changeVariantIsFired = false;
  function init2() {
    if (!section || !sectionId) {
      return false;
    }
    notifyMeButtonWrapper = section.querySelector(selectors2.notifyMeButtonWrapper);
    notifyMeButton = section.querySelector(selectors2.notifyMeButton);
    notifyMePopup = section.querySelector(selectors2.notifyMePopup);
    notifyMeForm = section.querySelector(selectors2.notifyMeForm);
    if (!notifyMeButton || !notifyMePopup || !notifyMeForm) {
      return false;
    }
    notifyMeFormId = notifyMeForm.id;
    notifyMeFormInputMessage = notifyMeForm.querySelector(selectors2.notifyMeFormInputMessage);
    notifyMeFormInputProductURL = notifyMeForm.querySelector(selectors2.notifyMeFormInputProductURL);
    notifyMeFormStatus = notifyMeForm.querySelector(selectors2.notifyMeFormStatus);
    if (!notifyMeFormInputMessage || !notifyMeFormInputProductURL || !notifyMeFormStatus) {
      return;
    }
    initToggle();
    initFormStatus();
    setEventBusListeners2();
  }
  function initToggle() {
    notifyMePopupToggle = Toggle2({
      toggleSelector: notifyMePopup.id
    });
    notifyMePopupToggle.init();
    on("click", notifyMePopup, function(e) {
      if (e.target == this) {
        notifyMePopupToggle.close(notifyMePopup);
      }
    });
    window.themeCore.EventBus.listen(`Toggle:${notifyMePopup.id}:close`, closeNotifyMePopup);
    window.themeCore.EventBus.listen(`Toggle:${notifyMePopup.id}:open`, openNotifyMePopup);
  }
  function initFormStatus() {
    if (isCurrentFormPosted()) {
      notifyMeForm.classList.add(cssClasses2.isPosted);
      notifyMePopupToggle.open(notifyMePopup);
    }
  }
  function isCurrentFormPosted() {
    return window.location.hash.includes(`#${notifyMeFormId}`) && notifyMeFormStatus.dataset.formStatus === "posted";
  }
  function closeNotifyMePopup() {
    if (isCurrentFormPosted()) {
      setTimeout(() => {
        notifyMeForm.classList.remove(cssClasses2.isPosted);
        section.classList.remove(cssClasses2.isNotifyMeActive);
      }, 400);
      let newUrl = new URL(window.location.href);
      newUrl.hash = "";
      newUrl.searchParams.delete(searchParams.contactPosted);
      newUrl.searchParams.delete(searchParams.contactProductUrl);
      newUrl.searchParams.delete(searchParams.contactMessage);
      newUrl.searchParams.delete(searchParams.formType);
      window.history.replaceState({}, null, newUrl.toString());
    }
  }
  function openNotifyMePopup() {
    section.classList.add(cssClasses2.isNotifyMeActive);
  }
  function setEventBusListeners2() {
    window.themeCore.EventBus.listen(`pdp:section-${sectionId}:change-variant`, onChangeVariant);
    if (!changeVariantIsFired) {
      const productElementJSON = section.querySelector("[data-js-product-json]");
      let productJSON;
      try {
        productJSON = JSON.parse(productElementJSON.innerText);
      } catch {
        productJSON = null;
      }
      if (!productJSON) {
        return;
      }
      if (productJSON.has_only_default_variant) {
        updateFormFields(productJSON.variants[0], productJSON);
        updateNotifyMeButton(productJSON.variants[0]);
      }
    }
  }
  function onChangeVariant({ variant, product }) {
    changeVariantIsFired = true;
    if (!variant || !product) {
      return false;
    }
    updateNotifyMeButton(variant);
    updateFormFields(variant, product);
  }
  function updateFormFields(variant, product) {
    const variantAvailable = variant.available;
    const variantId = variant.id;
    const productURL = product.url;
    const productTitle = product.title;
    if (variantAvailable || !variantId || !productURL || !productTitle) {
      notifyMeFormInputMessage.value = "";
      notifyMeFormInputProductURL.value = "";
      return false;
    }
    const variantURL = `${window.location.origin}${productURL}?variant=${variantId}`;
    const notifyMeMessage = notifyMeFormInputMessage.dataset.notifyMeMessage;
    notifyMeFormInputMessage.value = notifyMeMessage.replace(placeholders.productTitle, productTitle);
    notifyMeFormInputProductURL.value = variantURL;
  }
  function updateNotifyMeButton(variant) {
    const variantAvailable = variant.available;
    if (variantAvailable) {
      notifyMeButtonWrapper.classList.add(cssClasses2.hidden);
    } else {
      notifyMeButtonWrapper.classList.remove(cssClasses2.hidden);
    }
  }
  return Object.freeze({
    init: init2
  });
};
const ProductAskQuestion = (section) => {
  const sectionId = section && section.dataset.sectionId;
  const selectors2 = {
    askQuestionButton: ".js-ask-question-button",
    askQuestionPopup: ".js-ask-question-popup",
    askQuestionForm: ".js-ask-question-form",
    askQuestionFormStatus: ".js-ask-question-form-status",
    askQuestionFormInputProductURL: "[name='contact[product_url]']"
  };
  const cssClasses2 = {
    active: "is-active",
    isPosted: "is-posted",
    isNotifyMeActive: "is-ask-question-popup-active"
  };
  const searchParams = {
    contactPosted: "contact_posted",
    contactProductUrl: "contact[product_url]",
    contactMessage: "contact[body]",
    formType: "form_type"
  };
  const Toggle2 = window.themeCore.utils.Toggle;
  const on = window.themeCore.utils.on;
  let askQuestionButton = null;
  let askQuestionPopup = null;
  let askQuestionForm = null;
  let askQuestionFormInputProductURL = null;
  let askQuestionPopupToggle = null;
  let askQuestionFormStatus = null;
  let askQuestionFormId = null;
  let changeVariantIsFired = false;
  function init2() {
    if (!section || !sectionId) {
      return false;
    }
    askQuestionButton = section.querySelector(selectors2.askQuestionButton);
    askQuestionPopup = section.querySelector(selectors2.askQuestionPopup);
    askQuestionForm = section.querySelector(selectors2.askQuestionForm);
    if (!askQuestionButton || !askQuestionPopup || !askQuestionForm) {
      return false;
    }
    askQuestionFormId = askQuestionForm.id;
    askQuestionFormInputProductURL = askQuestionForm.querySelector(selectors2.askQuestionFormInputProductURL);
    askQuestionFormStatus = askQuestionForm.querySelector(selectors2.askQuestionFormStatus);
    if (!askQuestionFormInputProductURL || !askQuestionFormStatus) {
      return;
    }
    initToggle();
    initFormStatus();
    setEventBusListeners2();
  }
  function initToggle() {
    askQuestionPopupToggle = Toggle2({
      toggleSelector: askQuestionPopup.id
    });
    askQuestionPopupToggle.init();
    on("click", askQuestionPopup, function(e) {
      if (e.target == this) {
        askQuestionPopupToggle.close(askQuestionPopup);
      }
    });
    window.themeCore.EventBus.listen(`Toggle:${askQuestionPopup.id}:close`, closeAskQuestionPopup);
    window.themeCore.EventBus.listen(`Toggle:${askQuestionPopup.id}:open`, openQuestionPopup);
  }
  function initFormStatus() {
    if (isCurrentFormPosted()) {
      askQuestionForm.classList.add(cssClasses2.isPosted);
      askQuestionPopupToggle.open(askQuestionPopup);
    }
  }
  function isCurrentFormPosted() {
    return window.location.hash.includes(`#${askQuestionFormId}`) && askQuestionFormStatus.dataset.formStatus === "posted";
  }
  function closeAskQuestionPopup() {
    if (isCurrentFormPosted()) {
      setTimeout(() => {
        askQuestionForm.classList.remove(cssClasses2.isPosted);
        section.classList.remove(cssClasses2.isNotifyMeActive);
      }, 400);
      let newUrl = new URL(window.location.href);
      newUrl.hash = "";
      newUrl.searchParams.delete(searchParams.contactPosted);
      newUrl.searchParams.delete(searchParams.contactProductUrl);
      newUrl.searchParams.delete(searchParams.contactMessage);
      newUrl.searchParams.delete(searchParams.formType);
      window.history.replaceState({}, null, newUrl.toString());
    }
  }
  function openQuestionPopup() {
    section.classList.add(cssClasses2.isNotifyMeActive);
  }
  function setEventBusListeners2() {
    window.themeCore.EventBus.listen(`pdp:section-${sectionId}:change-variant`, onChangeVariant);
    if (!changeVariantIsFired) {
      const productElementJSON = section.querySelector("[data-js-product-json]");
      let productJSON;
      try {
        productJSON = JSON.parse(productElementJSON.innerText);
      } catch {
        productJSON = null;
      }
      if (!productJSON) {
        return;
      }
      if (productJSON.has_only_default_variant) {
        updateFormFields(productJSON.variants[0], productJSON);
      }
    }
  }
  function onChangeVariant({ variant, product }) {
    changeVariantIsFired = true;
    if (!variant || !product) {
      return false;
    }
    updateFormFields(variant, product);
  }
  function updateFormFields(variant, product) {
    const variantId = variant.id;
    const productURL = product.url;
    if (!variantId || !productURL) {
      askQuestionFormInputProductURL.value = "";
      return false;
    }
    const variantURL = `${window.location.origin}${productURL}?variant=${variantId}`;
    askQuestionFormInputProductURL.value = variantURL;
  }
  return Object.freeze({
    init: init2
  });
};
const ProductMediaScroller = (section) => {
  const selectors2 = {
    mediaContainer: ".js-product-media-container",
    mediaItem: ".js-product-media-item",
    mediaItemVariant: ".js-product-media-item-variant",
    header: ".js-header",
    cssRoot: ":root"
  };
  const attributes2 = {
    enableMediaScroller: "data-enable-media-scroller",
    staticHeader: "data-static-header",
    hideOnScrollHeader: "data-hide-on-scroll-down"
  };
  const cssVariables = {
    headerHeightStatic: "--header-height-static",
    headerHeight: "--header-height"
  };
  const breakpoints2 = {
    afterMedium: "(min-width: 1200px)"
  };
  const sectionId = section && section.dataset.sectionId;
  const cssRoot = document.querySelector(selectors2.cssRoot);
  let previousVariantId;
  function init2() {
    if (!section) {
      return;
    }
    const mediaContainer = section.querySelector(selectors2.mediaContainer);
    if (!mediaContainer) {
      return;
    }
    const enableMediaScroller = mediaContainer.hasAttribute(attributes2.enableMediaScroller);
    if (!enableMediaScroller) {
      return;
    }
    setEventBusListeners2();
  }
  function setEventBusListeners2() {
    window.themeCore.EventBus.listen(`pdp:section-${sectionId}:change-variant`, onChangeVariant);
  }
  function onChangeVariant({ variant, variantId, firstInitialization }) {
    if (previousVariantId === variantId) {
      return;
    }
    previousVariantId = variantId;
    const isDesktop = window.matchMedia(breakpoints2.afterMedium).matches;
    if (!isDesktop || firstInitialization) {
      return;
    }
    let variantMediaID = null;
    if (variant.featured_media) {
      variantMediaID = variant.featured_media.id;
    }
    const mediaContainer = section.querySelector(selectors2.mediaContainer);
    const mediaItems = mediaContainer.querySelectorAll(selectors2.mediaItem);
    const currentMediaItem = [...mediaItems].find((mediaItem) => {
      const mediaItemVariant = mediaItem.querySelector(selectors2.mediaItemVariant);
      if (!mediaItemVariant) {
        return false;
      }
      const mediaItemId = mediaItemVariant.getAttribute("data-media-id");
      return mediaItemId.includes(variantMediaID);
    });
    if (!currentMediaItem) {
      return null;
    }
    scrollToElement(currentMediaItem);
  }
  function scrollToElement(element) {
    const sectionBoundingClientRect = section.getBoundingClientRect();
    const elementBoundingClientRect = element.getBoundingClientRect();
    const elementTopOffset = Math.round(elementBoundingClientRect.top);
    const sectionTopOffset = Math.round(sectionBoundingClientRect.top);
    const sectionBottomOffset = Math.round(sectionBoundingClientRect.bottom);
    const windowScrollY = Math.round(window.scrollY);
    const scrollOffset = 8;
    let scrollTo = windowScrollY + elementTopOffset - scrollOffset;
    const containerTop = windowScrollY + sectionTopOffset - scrollOffset;
    const containerBottom = windowScrollY + sectionBottomOffset + scrollOffset;
    scrollTo = Math.max(scrollTo, containerTop);
    const currentHeaderHeight = getCurrentHeaderHeight();
    const currentScrollTo = scrollTo - currentHeaderHeight;
    if (Math.abs(windowScrollY - currentScrollTo) <= 1) {
      return;
    }
    const headerHeight = getHeaderHeight(windowScrollY, scrollTo);
    scrollTo = scrollTo - headerHeight;
    scrollTo = Math.min(scrollTo, containerBottom - window.innerHeight);
    window.scrollTo({
      top: scrollTo,
      behavior: "smooth"
    });
  }
  function getCurrentHeaderHeight() {
    const header = document.querySelector(selectors2.header);
    if (!header) {
      return 0;
    }
    const isHeaderStatic = header.hasAttribute(attributes2.staticHeader);
    if (isHeaderStatic) {
      return 0;
    }
    const headerHeightValue = cssRoot.style.getPropertyValue(cssVariables.headerHeight);
    return headerHeightValue ? parseInt(headerHeightValue) : 0;
  }
  function getHeaderHeight(windowScrollY, scrollTo) {
    const header = document.querySelector(selectors2.header);
    if (!header) {
      return 0;
    }
    const isHeaderStatic = header.hasAttribute(attributes2.staticHeader);
    const isHideOnScrollHeader = header.hasAttribute(attributes2.hideOnScrollHeader);
    const headerHeightStaticValue = cssRoot.style.getPropertyValue(cssVariables.headerHeightStatic);
    const headerHeightStatic = headerHeightStaticValue ? parseInt(headerHeightStaticValue) : 0;
    if (isHeaderStatic || isHideOnScrollHeader && windowScrollY < scrollTo - headerHeightStatic) {
      return 0;
    }
    return headerHeightStatic;
  }
  return Object.freeze({
    init: init2
  });
};
const ProductSection = (section) => {
  const Toggle2 = window.themeCore.utils.Toggle;
  const isElementInViewport = window.themeCore.utils.isElementInViewport;
  const off = window.themeCore.utils.off;
  const on = window.themeCore.utils.on;
  const cssClasses2 = window.themeCore.utils.cssClasses;
  const selectors2 = {
    mediaContainer: ".js-product-media-container",
    thumbnailsStacked: ".js-product-media-thumbnails-stacked",
    thumbnailsSlide: ".js-product-media-thumbnails-slide",
    slide: ".js-product-gallery-slide",
    modelButton: ".js-product-media-model-button",
    modelPoster: ".js-product-media-model-poster",
    modelContent: ".js-product-media-model-content"
  };
  const sectionId = section && section.dataset.sectionId;
  const carouselSelectors = {
    slider: `.js-product-media-slider-${sectionId}`,
    sliderNavigationNext: `.js-product-media-slider-next-${sectionId}`,
    sliderNavigationPrev: `.js-product-media-slider-prev-${sectionId}`,
    thumbNavigationNext: `.js-product-media-thumb-next-${sectionId}`,
    thumbNavigationPrev: `.js-product-media-thumb-prev-${sectionId}`,
    sliderSlideVariantId: `.js-product-gallery-slide-variant-${sectionId}`,
    sliderThumbnails: `.js-product-media-slider-thumbnails-${sectionId}`,
    sliderPagination: `.product-media__slider-pagination-${sectionId}`
  };
  const mediaContainerClasses = {
    stacked: "product-media--layout-stacked",
    stacked_2_col: "product-media--layout-stacked_2_col",
    stacked_2_col_with_big_img: "product-media--layout-stacked_2_col_with_big_image",
    slider: "product-media--layout-carousel"
  };
  const drawersSelectors = {
    sizeGuideDrawer: `productSizeGuideDrawer-${sectionId}`,
    descriptionDrawer: `descriptionDrawer-${sectionId}`,
    customDrawer1: `productDrawer1-${sectionId}`,
    customDrawer2: `productDrawer2-${sectionId}`,
    customDrawer3: `productDrawer3-${sectionId}`,
    customDrawer4: `productDrawer4-${sectionId}`
  };
  let Carousel = null;
  function init2() {
    const ProductZoom = Zoom(section);
    Carousel = ProductCarousel({
      selectors: carouselSelectors,
      sectionId
    });
    const productStickyForms = ProductStickyForm(section);
    ProductZoom.init();
    try {
      productStickyForms.init();
    } catch (e) {
      console.warn("[product] sticky form init skipped", e);
    }
    initCarousel();
    setDrawers();
    initModelButtons();
    initNotifyMe();
    initAskQuestion();
    const productHandle = section.dataset.productHandle;
    if (!productHandle) {
      return;
    }
    let recentlyViewed = localStorage.getItem("theme_recently_viewed");
    if (recentlyViewed) {
      try {
        recentlyViewed = JSON.parse(recentlyViewed);
        recentlyViewed = [.../* @__PURE__ */ new Set([...recentlyViewed, productHandle])];
        recentlyViewed = recentlyViewed.slice(-11);
        localStorage.setItem("theme_recently_viewed", JSON.stringify(recentlyViewed));
      } catch (e) {
        console.log(e);
      } finally {
        return;
      }
    }
    localStorage.setItem("theme_recently_viewed", `["${productHandle}"]`);
  }
  function initCarousel() {
    const mediaContainer = section.querySelector(selectors2.mediaContainer);
    if (!mediaContainer) {
      return;
    }
    const mediaLayout = mediaContainer.dataset.mediaLayout;
    if (!mediaLayout) {
      return;
    }
    if (mediaLayout === "carousel") {
      Carousel.init();
    }
    if (mediaLayout === "stacked" || mediaLayout === "stacked_2_col" || mediaLayout === "stacked_2_col_with_big_image") {
      updateMedia();
      on("scroll", document, onScroll);
      activeDragThumbnail();
      on("resize", updateMedia);
      ProductMediaScroller(section).init();
    }
  }
  function updateMedia() {
    const mediaContainer = section.querySelector(selectors2.mediaContainer);
    if (!mediaContainer) {
      return;
    }
    const mediaLayout = mediaContainer.dataset.mediaLayout;
    let stackedClass = mediaContainerClasses.stacked;
    if (mediaLayout === "stacked_2_col") {
      stackedClass = mediaContainerClasses.stacked_2_col;
    } else if (mediaLayout === "stacked_2_col_with_big_image") {
      stackedClass = mediaContainerClasses.stacked_2_col_with_big_img;
    }
    /* Desktop: stacked collage (hero + tiles). Mobile/tablet: main image swiper only.
       Switch layout classes BEFORE Carousel.init() so Swiper measures carousel layout
       (init-then-class left slides sized wrong and only the first image worked). */
    if (window.innerWidth >= 1200) {
      Carousel.destroy();
      mediaContainer.classList.add(stackedClass);
      mediaContainer.classList.remove(mediaContainerClasses.slider);
    } else {
      mediaContainer.classList.add(mediaContainerClasses.slider);
      mediaContainer.classList.remove(stackedClass);
      Carousel.init();
    }
  }
  function onScroll() {
    off("scroll", document, onScroll);
    const mediaContainer = section.querySelector(selectors2.mediaContainer);
    const thumbnailsStacked = section.querySelector(selectors2.thumbnailsStacked);
    if (!mediaContainer || !thumbnailsStacked) {
      return;
    }
    const slides = [...mediaContainer.querySelectorAll(selectors2.slide)];
    slides.forEach((slide) => {
      setTimeout(() => {
        if (isElementInViewport(slide, thumbnailsStacked, 200)) {
          const thumbnails = [...thumbnailsStacked.querySelectorAll(selectors2.thumbnailsSlide)];
          thumbnails.forEach((thumbnail) => {
            thumbnail.classList.remove(cssClasses2.active);
          });
          const currentThumbnail = thumbnails.find((thumbnail) => thumbnail.dataset.mediaId === slide.dataset.mediaId);
          if (currentThumbnail) {
            currentThumbnail.classList.add(cssClasses2.active);
            const offsetTopThumbnail = currentThumbnail.offsetTop;
            const offsetHeightContainer = thumbnailsStacked.offsetHeight / 2;
            const offsetHeightThumbnail = currentThumbnail.offsetHeight / 2;
            const scroll = offsetTopThumbnail - offsetHeightContainer + offsetHeightThumbnail;
            thumbnailsStacked.scroll(0, scroll);
          }
        }
        on("scroll", document, onScroll);
      }, 700);
    });
  }
  function activeDragThumbnail() {
    const thumbnail = section.querySelector(selectors2.thumbnailsStacked);
    if (!thumbnail) {
      return;
    }
    let pos = { top: 0, left: 0, x: 0, y: 0 };
    let isDrag = false;
    const mouseDownHandler = function(e) {
      thumbnail.style.cursor = "grabbing";
      thumbnail.style.userSelect = "none";
      thumbnail.style.scrollBehavior = "auto";
      pos = {
        left: thumbnail.scrollLeft,
        top: thumbnail.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY
      };
      on("mousemove", document, mouseMoveHandler);
      on("mouseup", document, mouseUpHandler);
    };
    const mouseMoveHandler = function(e) {
      const dx = e.clientX - pos.x;
      const dy = e.clientY - pos.y;
      isDrag = Boolean(dx + dy);
      thumbnail.scrollTop = pos.top - dy;
      thumbnail.scrollLeft = pos.left - dx;
    };
    const mouseUpHandler = function() {
      const anchors = [...thumbnail.querySelectorAll("a")];
      if (anchors && isDrag) {
        const preventDefault = (e) => {
          e.preventDefault();
          anchors.forEach((anchor) => {
            off("click", anchor, preventDefault);
          });
          isDrag = false;
        };
        anchors.forEach((anchor) => {
          on("click", anchor, preventDefault);
        });
      }
      document.removeEventListener("mousemove", mouseMoveHandler);
      document.removeEventListener("mouseup", mouseUpHandler);
      thumbnail.style.cursor = "grab";
      thumbnail.style.removeProperty("user-select");
      thumbnail.style.scrollBehavior = "smooth";
    };
    on("mousedown", thumbnail, mouseDownHandler);
  }
  function setDrawers() {
    try {
      setToggleDrawer(drawersSelectors.sizeGuideDrawer, { hasFullWidth: true });
      setToggleDrawer(drawersSelectors.descriptionDrawer);
      setToggleDrawer(drawersSelectors.customDrawer1);
      setToggleDrawer(drawersSelectors.customDrawer2);
      setToggleDrawer(drawersSelectors.customDrawer3);
      setToggleDrawer(drawersSelectors.customDrawer4);
    } catch (e) {
    }
  }
  function setToggleDrawer(selector, options = {}) {
    const toggleButton = document.querySelector(`[data-js-toggle="${selector}"]`);
    if (!toggleButton) {
      return;
    }
    const ToggleDrawer = Toggle2({
      toggleSelector: selector,
      ...options
    });
    ToggleDrawer.init();
    if (selector === drawersSelectors.sizeGuideDrawer) {
      let sizeGuideDrawer = document.getElementById(drawersSelectors.sizeGuideDrawer);
      if (!sizeGuideDrawer) {
        return;
      }
      on("click", sizeGuideDrawer, function(e) {
        if (e.target == this) {
          ToggleDrawer.close(sizeGuideDrawer);
        }
      });
    }
  }
  function initModelButtons() {
    const modelButtons = [...section.querySelectorAll(selectors2.modelButton)];
    if (!modelButtons.length) {
      return;
    }
    section.addEventListener("click", (event) => {
      const button = event.target.closest(selectors2.modelButton);
      if (!button) {
        return;
      }
      const container = button.parentElement;
      const poster = container.querySelector(selectors2.modelPoster);
      const content = container.querySelector(selectors2.modelContent);
      if (!poster || !content) {
        return;
      }
      poster.remove();
      button.remove();
      content.classList.remove(cssClasses2.hidden);
      Carousel.disableSwipe();
    });
  }
  function initNotifyMe() {
    const productNotifyMe = ProductNotifyMe(section);
    productNotifyMe.init();
  }
  function initAskQuestion() {
    const productAskQuestion = ProductAskQuestion(section);
    productAskQuestion.init();
  }
  return Object.freeze({
    init: init2
  });
};
const selectors = {
  section: '[data-section-type="product"]',
  productAvailabilityToggleSelector: "[data-js-toggle-selector]",
  mediaContainer: ".js-product-media-container",
  video: ".js-video",
  slide: ".js-product-gallery-slide",
  paused: ".js-paused-video",
  placeholder: ".js-product-gallery-video-placeholder"
};
const videos = [];
let Video;
let sections;
let ProductForms;
let Toggle;
let cssClasses;
async function init(sectionId) {
  Video = window.themeCore.utils.Video;
  Toggle = window.themeCore.utils.Toggle;
  cssClasses = {
    ...window.themeCore.utils.cssClasses,
    pausedVideo: "is-paused-video"
  };
  sections = [...document.querySelectorAll(selectors.section)].filter((section) => !sectionId || section.closest(`#shopify-section-${sectionId}`));
  ProductForms = ProductForm();
  // Init forms FIRST so a sticky/carousel failure cannot block variant handlers
  ProductForms.init();
  sections.forEach((section) => {
    try {
      initSection(section);
    } catch (err) {
      console.warn("[product] section init error", err);
    }
  });
  initVideos();
  setEventBusListeners();
  window.themeCore.EventBus.emit("product:loaded");
}
function initSection(section) {
  const productSection = ProductSection(section);
  window.themeCore.EventBus.listen(
    `pickup-availability-drawer:productAvailability-pickup-availability__${section.dataset.sectionId}:loaded`,
    () => {
      const productAvailabilityToggles = [
        ...document.querySelectorAll(
          selectors.productAvailabilityToggleSelector
        )
      ];
      const productAvailabilityToggle = productAvailabilityToggles.find(
        (toggle) => {
          return toggle.dataset.jsToggle === `productAvailability-pickup-availability__${section.dataset.sectionId}`;
        }
      );
      const productAvailability = Toggle({
        toggleSelector: productAvailabilityToggle.dataset.target
      });
      productAvailability.init();
    }
  );
  window.setTimeout(() => {
    handlerPauseVideo(section);
  }, 0);
  try {
    productSection.init();
  } catch (err) {
    console.warn("[product] ProductSection.init failed", err);
  }
}
function handlerPauseVideo(section) {
  const mediaContainer = section.querySelector(selectors.mediaContainer);
  if (!mediaContainer) {
    return;
  }
  mediaContainer.addEventListener("click", (event) => {
    const paused = event.target.closest(selectors.paused);
    if (!paused || !paused.classList.contains(cssClasses.pausedVideo)) {
      return;
    }
    const placeholder = paused.querySelector(selectors.placeholder);
    const videoEl = paused.querySelector(selectors.video);
    pauseVideos(videoEl);
    if (placeholder) {
      paused.classList.remove(cssClasses.pausedVideo);
      placeholder.classList.add(cssClasses.hidden);
      videos.forEach(({ player, videoWrapper, type }) => {
        if (videoWrapper === videoEl) {
          playVideo(player, type);
        }
      });
    }
  });
}
function playVideo(player, type) {
  const VIDEO_TYPES = window.themeCore.utils.VIDEO_TYPES;
  switch (type) {
    case VIDEO_TYPES.html: {
      player.play();
      break;
    }
    case VIDEO_TYPES.vimeo: {
      player.play();
      break;
    }
    case VIDEO_TYPES.youtube: {
      player.mute();
      player.playVideo();
      break;
    }
    default:
      return;
  }
}
function pauseVideos(currentVideo) {
  videos.forEach(({ player, videoWrapper }) => {
    if (videoWrapper === currentVideo) {
      return;
    }
    try {
      player.pauseVideo();
    } catch (e) {
    }
    try {
      player.pause();
    } catch (e) {
    }
  });
}
function setEventBusListeners() {
  window.themeCore.EventBus.listen("product-slider:slide-change", pauseVideos);
  window.themeCore.EventBus.listen("product:zoom:open", pauseVideos);
}
function initVideos() {
  const slides = [...document.querySelectorAll(selectors.slide)];
  slides.forEach((slide) => {
    const [video] = Video({
      videoContainer: slide,
      options: {
        youtube: {
          controls: 1,
          showinfo: 1
        }
      }
    }).init();
    if (video) {
      videos.push(video);
    }
  });
}
const Product = () => {
  return Object.freeze({
    init
  });
};
export {
  Product as P
};
